import { render, staticRenderFns } from "./localization-text-field.vue?vue&type=template&id=33a9ad12&scoped=true&"
import script from "./localization-text-field.vue?vue&type=script&lang=js&"
export * from "./localization-text-field.vue?vue&type=script&lang=js&"
import style0 from "./localization-text-field.vue?vue&type=style&index=0&id=33a9ad12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a9ad12",
  null
  
)

export default component.exports